import { Search } from '@/DTOS/CompanyGroup/Search';
import request from '../../utils/request';

const UserGroupService = {
  search: (search: Search) => {
    return request('/userGroup/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  upsert: (
    /** @type {any} */ id: any,
    /** @type {{ name: any; isActive: any; }} */ formData: {
      name: any;
      supervisors: any;
      isActive: any;
    }
  ) => {
    return request('/userGroup/upsert', {
      method: 'POST',
      body: JSON.stringify({
        request: {
          id: id,
          name: formData.name,
          supervisors: formData.supervisors,
          isActive: formData.isActive,
        },
      }),
    });
  },
};

export default UserGroupService;
